import { useSelector } from 'react-redux';

import { currentOpenChatSelector, isShowSubAgentChatListSelector, userIdSelector } from '../../../selectors';

export const useOutcomingMessageStyle = (isOutcoming: boolean, messageUserId: number): boolean => {
  const userId = useSelector(userIdSelector);
  const { users = [] } = useSelector(currentOpenChatSelector) || {};
  const isShowSubAgentChatList = useSelector(isShowSubAgentChatListSelector);

  const currentUser = users.find(user => user.userId === userId);
  const messageUser = users.find(user => user.userId === messageUserId);

  // Если зашли за мастера считаем сообщения оппонента - исходящими
  if (currentUser?.chatRole === 'master' && messageUser?.chatRole === 'opponent') {
    return true;
  }

  // Если мастер просматривает сообщения субагента считаем сообщения оппонента - исходящими
  if (isShowSubAgentChatList && messageUser?.chatRole === 'opponent') {
    return true;
  }

  // Если зашли за оппонента считаем сообщения мастера - исходящими
  if (currentUser?.chatRole === 'opponent' && messageUser?.chatRole === 'master') {
    return true;
  }

  return isOutcoming;
};
